/* unplugin-vue-components disabled */import script from "./GlobalFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&setup=true&lang=js"

import "./GlobalFooter.vue?vue&type=style&index=0&id=6b08a0e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b08a0e0"]])

export default __exports__